export default __webpack_public_path__ + "static/media/ecosystem.deda76ee.svg";